import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, HostListener, input, output, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';

import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  UntypedFormBuilder,
} from '@angular/forms';

import { DrawerModule } from 'primeng/drawer';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';

import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { InputMaskModule } from 'primeng/inputmask';
import { ChargeBreakUp, ChargingTodaySignUp, Claim, OverLappingSubscriptionSignUpResponse, PaymentSignUp,
        PlanBreakUpCalculation, PlanBreakUpCalculationResponse, PlanMasterList, PlanSummary, RecurringSignUp, ServiceBreakUp, 
        ServiceTypeResponse, TaxLineItemBreakUp, TenantById, ValidationError, ChargeMaster, ChargeMasterById, ChargeBreakUpCalculationRequest, 
        ClientOrderResponse, TENANTSINTERFACE, ChargeCreateRequest, StaffDiscountSignUpChargeRequest, StaffDiscountCalculationRequest,
         StaffDiscountChargeRecurring, StaffDiscountChargingTodayRequest, StaffDiscountServiceFirstChargeRequest, StaffDiscountServiceNonRecurringRequest, 
         StaffDiscountServiceRecurringRequest, STAFFINTERFACE, RetailProduct, SubscriptionCharge, RetailProducts, BillingRetailProduct,
         AppErrors, NotFoundError,ClaimConstant, PosDeviceSale, PaymentGatewatMaster, PosTerminal, GetOrderStatusOfQuotation  } from '@fitness-force/models';
import { BehaviorSubject, catchError, combineLatest, combineLatestWith, filter, interval, map, Observable, of, retryWhen, scan, Subject, Subscription, switchMap, take, takeUntil, throwError, timer } from 'rxjs';
import {
  AdvancedSettingService,
  AuthSevices,
  ChargeMasterService,
  ClaimService,
  ClientService,
  CommonService,
  PaymentGatewayMasterService,
  PaymentModeService,
  PlansubscriptionService,
  StaffService,
  TimeconversionService,
  ToastMessageService,
  extractApiErrorMessages,
} from '@fitness-force/api';
import { ErrorMsgComponent, ErrorsComponent } from '@fitness-force/errors';;
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import {AssignedToComponent} from '@fitness-force/common/assigned-to'

import {
  PlanIntervalType,
  PlanType,
  Roles,
  Status,
} from '@fitness-force/enum';
import {
  COMPANY_INFO,
  STAFF_STATE,
  TENANTS_INFO,
} from '@fitness-force/state';
import { Store } from '@ngrx/store';
import { SkeletonModule } from 'primeng/skeleton';
import { InputNumberModule } from 'primeng/inputnumber';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { StyleClassModule } from 'primeng/styleclass';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { ActivatedRoute } from '@angular/router';
import { OtherPaymentComponent, SavedPaymentMethodsPopupComponent } from '@fitness-force/common/payment';
import {  ShortNamePipe} from '@fitness-force/pipes/short-name'
import { PopoverModule } from 'primeng/popover';
import { environment } from '@fitness-force/environments';
import { FeatureFlagService, RouteStateService } from '@fitness-force/shared-utils';
import { ProductFulfillmentPopupComponent, ProductFulfillmentItem } from '../product-fulfillment-popup/product-fulfillment-popup.component';
import { PosDeviceListComponent, PosDeviceListCloseEvent } from '../pos-device-list/pos-device-list.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {
  OrderSubscriptionStatusPollingService,
  type SignupPaymentPollTerminalOutcome,
} from '../services/order-subscription-status-polling.service';
import { getOnlinePaymentFailureReason } from '../services/signup-payment-poll.util';


@Component({
  selector: 'pos-billing-summary',
  templateUrl: './pos-billing-summary.component.html',
  styleUrls: ['./pos-billing-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    InputNumberModule,
    ButtonModule,
    DrawerModule,
    AvatarModule,
    AvatarGroupModule,
    SelectModule,
    TooltipModule,
    DividerModule,
    DatePickerModule,
    ReactiveFormsModule,
    RadioButtonModule,
    MessageModule,
    SkeletonModule,
    CurrencyformatPipe,
    AssignedToComponent,
    ErrorsComponent,
    ErrorMsgComponent,
    StyleClassModule,
    InputTextModule,
    InputMaskModule,
    DialogModule,
    OtherPaymentComponent,
    ShortNamePipe,
    PopoverModule,
    DialogModule,
    TranslateModule,
    ProductFulfillmentPopupComponent,
    SavedPaymentMethodsPopupComponent,
    PosDeviceListComponent,
    ProgressSpinnerModule,
    AsyncPipe,
    TitleCasePipe
]
})
export class PosBillingSummaryComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly translate = inject(TranslateService);
  private readonly clientService = inject(ClientService);
  private readonly plansubscriptionService = inject(PlansubscriptionService);
  private readonly commonService = inject(CommonService);
  private readonly authService = inject(AuthSevices);
  paymentModeService = inject(PaymentModeService);
  private readonly timeService = inject(TimeconversionService);
  private readonly staffService = inject(StaffService);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly activatedRouter = inject(ActivatedRoute);
  private readonly advanceSettingService = inject(AdvancedSettingService);
  private readonly chargeMasterService = inject(ChargeMasterService);
  private readonly claimService = inject(ClaimService);
  private readonly featureFlagService = inject(FeatureFlagService);
  private readonly paymentGatewayMasterService = inject(PaymentGatewayMasterService);
  private readonly stateService = inject(RouteStateService);
  private readonly orderSubscriptionStatusPollingService = inject(
    OrderSubscriptionStatusPollingService
  );
  private readonly cd = inject(ChangeDetectorRef);

  readonly showPosBillingSidebar = input(false, { alias: "visible" });
  readonly posDetails$ = input.required<Observable<any>>({ alias: "posSummaryData" });
  readonly isCartFlow = input(false);
  readonly billedAtTenantId = input(0);
  readonly billedForTenantId = input(0);
  readonly latestBreakUpCalculationRequest = input<ChargeBreakUpCalculationRequest | null>(null);
  readonly closeSidePopup = output<{
    hideSidebar: boolean;
    clientSignupUUID: string;
    ispayment: boolean;
    skipPaymentPolling?: boolean;
    suppressPaymentTimeline?: boolean;
}>();
  readonly addToCart = output<{
    type: string;
    object: any;
}>();


  disablePlanDropdown = false;
  getAccessTenantList$!: Observable<any>;
  tenantId = 0;
  loggedInTenantId = 0;
  subscriptionPlanId = 0;
  clientId = 0;
  clientName = '';
  isInclusive = false;
  isContract$ = new BehaviorSubject<boolean>(false);
  isCashRecurring = false;
  otherpayment = true;
  offlinePaymentPopup = false;
  otherPaymentsModal = false;
  billing_interval_type$ = new BehaviorSubject<string>('');
  billing_interval_value$ = new BehaviorSubject<number>(0);
  subscription_category$ = new BehaviorSubject<string>('');
  bill_cycle_day!: string;
  fg: UntypedFormGroup = new UntypedFormGroup({});
  planIntervalType = PlanIntervalType;
  planCategory = PlanType;
  oJSON!: JSON;
  isSubmitting = false;
  serviceTypeCollection!: Option[];
  errMsg: Error | any;
  error = new BehaviorSubject(null as AppErrors | null);
  boolshowSessionOwner = false;

  claim$: Observable<Claim[]> = new Observable();
  fgProducts: UntypedFormGroup = new UntypedFormGroup({
    charges: new UntypedFormArray([]),
    charges_reason : new UntypedFormControl('', []),
    products: new UntypedFormArray([]),
  });

  userDiscountLimit = 0;
  single_staff_discount = 0;
  recurring_staff_discount = 0;
  billingCycleOption$ = new BehaviorSubject<any[]>([]);
  isProRata$ = new BehaviorSubject(true);
  totalNonRecurringAmt$ = new BehaviorSubject(0);
  isTaxInClusive = false;
  billOwnerId$ = new BehaviorSubject<number>(0);

  planBreakUpCalculationResponse$ = new BehaviorSubject<PlanBreakUpCalculationResponse>(null!);
  overLappingSubscriptionSignUp$ = new BehaviorSubject<OverLappingSubscriptionSignUpResponse>(null!);
  planBreakUpCalculation$: BehaviorSubject<PlanBreakUpCalculation | null> = new BehaviorSubject<PlanBreakUpCalculation | null>(null);
  planSubscription$: BehaviorSubject<PlanMasterList[] | null> = new BehaviorSubject<PlanMasterList[] | null>(null);

  billdate: Date = new Date();
  maxStartDate = new Date();
  minStartDate = new Date();

  clientSignupUUID = '';
  selectedMembership: | { name: string; duration: string; amount: string } | undefined;
  startDate: Date | undefined;

  onlinePayment = false;
  // otherPayment: boolean = false;
  requiredInformation = false;

  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  errorDataModal = [] as ValidationError[];
  currentUserDetails: any;

  referredBy: number = 0;
  tenantDetails: TenantById = {} as TenantById;

  // Saved payment methods
  showPayViaSavedPaymentMethods = false;
  showSavedPaymentMethodsPopup = new BehaviorSubject<boolean>(false);
  selectedCardOnFileTokenId: number | null = null;
  countryCode = '';
  private readonly destroy$ = new Subject<void>();
  disableChargeMasterDropdown: boolean = false;
  chargeMasterid: number = 0;
  clientIds: any;
  activeClientId: any;
  chargeCategoryCollection: Option[] = [];
  chargeMasterList$ = new BehaviorSubject<ChargeMaster[]>([]);
  chargeMaster$: Observable<ChargeMasterById> = new Observable();
  chargeMaster: ChargeMasterById = {} as ChargeMasterById;
  totalBalance$ = new BehaviorSubject<number>(0);
  otherPaymentsModal$ = new BehaviorSubject<boolean>(false);

  showChargeOnPosTerminal = false;
  showDeviceList = false;
  posGatewaysLoaded = false;
  posDeviceSale: PosDeviceSale | undefined;
  paymentGatewayList = new BehaviorSubject<PaymentGatewatMaster[]>([]);
  paymentGateway: PaymentGatewatMaster = {} as PaymentGatewatMaster;
  paymentFailed = false;
  paymentFailedMessages: string[] = [];
  transactionInProcess = false;
  paymentConfirmationPending = false;
  paymentConfirmationTimedOut = false;
  paymentConfirmationShowTimeLimit = false;
  paymentConfirmationSecondsRemaining = 0;
  private paymentConfirmationOrderUuid = '';
  private paymentConfirmationPosFlow = false;
  private pendingPaymentConfirmation = false;
  private paymentConfirmationCountdownSub?: Subscription;
  private readonly POS_PAYMENT_TIMEOUT_MS = 2 * 60 * 1000;
  private blockPaymentTimeline = false;

  applyDiscount: boolean = false;
  applyCoupon: boolean = false;
  couponApplied: boolean = false;
  discountApplied: boolean = false;
  inValidDiscount: boolean = false;
  alreadyDiscountApplied = new BehaviorSubject(false);
  inValidRecurringDiscount: boolean = false;
  _issueDate = "";
  changeBillingName = false;
  billingNameForm: UntypedFormGroup = new UntypedFormGroup({ billing_name: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]) });
  clientCreditBalance: number = 0;
  _selectedstaff = new BehaviorSubject<number>(0);
  _filterStaff = new BehaviorSubject<number[]>([0]);
  _sessionOwner = new BehaviorSubject<number[]>([0]);
  billingName = '';

  posDetails: PlanSummary | null = null;
  isStartDateChanged: boolean = false;

  // Product fulfillment popup properties
  showProductFulfillmentPopup = false;
  productFulfillmentItems: ProductFulfillmentItem[] = [];
  paymentAmount: number = 0;

  subscription: Subscription = new Subscription();

  constructor() {
    this.currentUserDetails = this.authService.decodedToken;
    this.componentInit();
  }

  ngOnInit(): void {

    this.maxStartDate = new Date(new Date().setHours(23,59,59));
    this.subscription = this.posDetails$().subscribe((plan: PlanSummary) => {
      this.posDetails = plan;
      const billedfortenantId=this.billedForTenantId();
      // Only set tenantId if billedForTenantId has a valid value
      if (billedfortenantId > 0) {
        this.tenantId = billedfortenantId;
      }
      this.clientId = plan.client.client_id;
      this.clientName = plan.client.client_name;
      if(plan.summaryType?.toLowerCase() == 'charge') {
        this.chargeMasterid = plan.id;
      }
      this.disableChargeMasterDropdown = plan.id == 0 && plan.summaryType?.toLowerCase() == 'charge';
      this.activeClientId = plan.client.client_id;
      this.billingName = plan.billingName || '';
      this.billingNameForm.patchValue({billing_name: this.billingName});
      this.getSettings();
      if(plan.id == 0)
      {
        this.BindServiceType();
        this.ListChargeMaster();
        this.disableChargeMasterDropdown= true;
        //this.ChargeMaster(plan.id);
      }
      else{
        if(plan.summaryType?.toLowerCase() == 'charge') {
          this.ChargeMaster(plan.id);
        }
        this.bindChargeBreakUp(this.billedForTenantId());
        this.disableChargeMasterDropdown= false;
      }
      this.filterStaff();
      this.getClientCreditBalance();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.clearPaymentConfirmationCountdown();
    this.orderSubscriptionStatusPollingService.stopPolling();
    this.destroy$.next();
    this.destroy$.complete();
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      this.loggedInTenantId = tenant.selected_tenant.id;
      this.countryCode = tenant.selected_tenant.country || '';
     // this.billedAtTenantId = this.tenantId;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });
    this.claim$ = this.claimService.GetClaim(environment.BASE_URL);
    this.activatedRouter.params.subscribe((params: any) => {
      if (params.clientId) {
        this.activeClientId = params.clientId;
      }
    });
    this.single_staff_discount = this.currentUserDetails.single_staff_discount;
    this._issueDate = this.timeService.ConvertLocalDateTimeToUTC(new Date());
    this.SetFormFields();

    this.featureFlagService.getFlag$('show_card_on_file')
      .pipe(takeUntil(this.destroy$))
      .subscribe((showCardOnFile: boolean) => {
        this.showPayViaSavedPaymentMethods = showCardOnFile;
        this.cd.markForCheck();
      });

    this.featureFlagService.getFlag$('show_charge_on_terminal_or_pos')
      .pipe(takeUntil(this.destroy$))
      .subscribe((showChargeOnPosTerminal: boolean) => {
        this.showChargeOnPosTerminal = showChargeOnPosTerminal;
        this.cd.markForCheck();
      });
  }

  getClientCreditBalance() {
    this.clientService.getClientCreditBalanceByTenantId(this.clientId, this.tenantId).subscribe({
      next: (res: any) => {
        this.clientCreditBalance = res;
      }
    });
  }

  SetFormFields(): void {
    this.fg = this.fb.group({
      ddlplanSubscriptionList: new UntypedFormControl(null, []),
      billdate: new UntypedFormControl(new Date(), []),
      billingOwner: new UntypedFormControl('', [Validators.required]),
    });

    this.fg.controls.ddlplanSubscriptionList.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((charge: ChargeMaster) => {
        if (charge?.id) {
          this.chargeMasterid = charge.id;
          this.ChargeMaster(charge.id);
        }
      });
  }

  BindServiceType(): void {
    this.chargeMasterService.getChargeCategoryMasters(this.billedForTenantId()).subscribe({
      next: (chargeCatTypes: any) => {
        this.chargeCategoryCollection = [];
        chargeCatTypes.items.forEach((catType: ServiceTypeResponse) => {
          const status = catType.status.toString();
          const varStatus: string = Status[Status.Active];
          if (status === varStatus) {
            this.chargeCategoryCollection.push({
              name: catType.name_primary_language,
              value: catType.id,
            });
          }
        });
      }
    });
  }

  ListChargeMaster() {
    this.chargeMasterService.getChargeMasters(this.billedForTenantId()).subscribe({
      next: (chargeList: any) => {
        const chargeMasterList = chargeList.items as ChargeMaster[];
        this.chargeMasterList$.next(chargeMasterList.filter(o => o.status.toString() === Status[Status.Active] || o.status == Status.Active));
      }
    });
  }

  ChargeMaster(chargerMasterId: number) {
    this.chargeMaster$ = this.chargeMasterService.getSingleChargeMaster(this.billedForTenantId(), chargerMasterId);
    this.chargeMaster$.subscribe({
      next: (chargeMaster: ChargeMasterById) => {
        this.chargeMaster = chargeMaster;
        this.bindChargeBreakUp(this.billedForTenantId());
      }
    });
  }

  getChargeDetails(chargeId: number) {
    return this.chargeMasterList$.value.find(o => o.id == chargeId);
  }

  filterStaff() {
    let claim: Claim[] = {} as Claim[];
    let staffs: STAFFINTERFACE[] = [];
    const validStaff: number[] = [];

    if(this.loggedInTenantId == this.billedForTenantId()) {
    this.claim$.pipe(combineLatestWith(this.store.select(STAFF_STATE)))
      .subscribe(([objClaim, objStaff]) => {
        claim = objClaim;
        staffs = objStaff.staffList;
        if (staffs.length > 0) {
          staffs.forEach((stf) => {
            if (
              stf.role == Roles.Admin ||
              stf.role.toString() == Roles[Roles.Admin] ||
              stf.role == Roles.FFAdmin ||
              stf.role.toString() == Roles[Roles.FFAdmin] ||
              claim.filter(
                (o) =>
                  o.id == stf.claim_template_id &&
                  (o.can_admin_billing == true || o.can_do_billing == true)
              ).length > 0
            )
              validStaff.push(stf.id);
          });
          this._filterStaff.next(validStaff);
        }
        if (this.authService.currentUserDetails()) {
          const currentUserDetails = this.authService.currentUserDetails();
          if (
            currentUserDetails.role.toLowerCase() == 'admin' ||
            currentUserDetails.can_do_billing == 'true' ||
            currentUserDetails.can_admin_billing == 'true'
          ) {
            this._selectedstaff.next(Number(this.authService.loggedInStaffId));
          }
        }
      });
    }else{
      const staffListParams = new Map();
      staffListParams.set('PageNumber', { name: 'PageNumber', value: 1 });
      staffListParams.set('PageSize', { name: 'PageSize', value: 9999 });
      staffListParams.set('page_number', { name: 'page_number', value: 1 });
      staffListParams.set('page_size', { name: 'page_size', value: 9999 });
      this.claim$.pipe(combineLatestWith(this.staffService.GetStaffList( environment.BASE_URL, this.tenantId, Array.from(staffListParams.values()))))
      .subscribe(([objClaim, objStaff]) => {
        claim = objClaim;
        staffs = objStaff.items;

        if (staffs.length > 0) {
          staffs.forEach((stf) => {
            if (
              stf.role == Roles.Admin ||
              stf.role.toString() == Roles[Roles.Admin] ||
              stf.role == Roles.FFAdmin ||
              stf.role.toString() == Roles[Roles.FFAdmin] ||
              claim.filter(
                (o) =>
                  o.id == stf.claim_template_id &&
                  (o.can_admin_billing == true || o.can_do_billing == true)
              ).length > 0
            )
              validStaff.push(stf.id);
          });
          this._filterStaff.next(validStaff);
        }
      });
    }
  }


  bindChargeBreakUp(tenant_id: number): void {
    let chargeBreakUpCalculationRequest: ChargeBreakUpCalculationRequest = {} as ChargeBreakUpCalculationRequest;
    chargeBreakUpCalculationRequest = {
      client_id: this.clientId,
      coupon_code: '',
      is_coupon_code_applied: false,
      issue_date: this._issueDate,
      charge_master_ids: this.chargeMasterid > 0 ? [this.chargeMasterid] : []
    };
   
    if(this.posDetails?.subscriptionProductsAndCharges && ((this.posDetails?.subscriptionProductsAndCharges.products && this.posDetails?.subscriptionProductsAndCharges.products.length > 0) || (this.posDetails?.subscriptionProductsAndCharges.charges && this.posDetails?.subscriptionProductsAndCharges.charges.length > 0)))
    {
      const products:RetailProducts[] = [];
      const charges:SubscriptionCharge[] = [];
      this.posDetails?.subscriptionProductsAndCharges.products.forEach(o => {
        products.push({
          sku_id: o.sku_id,
          quantity: o.quantity,
          is_plan_sku: o.is_plan_sku,
          is_fulfilled: o.is_fulfilled
        });
      });
      this.posDetails?.subscriptionProductsAndCharges.charges.forEach(o => {
        charges.push({
          charge_id: o.charge_id,
          is_plan_charge: o.is_plan_charge,
        });
      });

      // if(this.chargeMasterid)
      // {
      //   charges.push({
      //     charge_id: this.chargeMasterid,
      //     is_plan_charge: false,
      //   });
      // }
      chargeBreakUpCalculationRequest.products = products;
      chargeBreakUpCalculationRequest.charges = charges;
      if (charges.length > 0) {
        chargeBreakUpCalculationRequest.charge_master_ids = charges.map((charge) => charge.charge_id);
      }
    }
    this.plansubscriptionService.getChargeBreakUpCalculation(tenant_id, chargeBreakUpCalculationRequest)
      .subscribe({
        next: (_objResponse: PlanBreakUpCalculationResponse) => {
          this.errorMessages = [];
          if (_objResponse.plan_breakup_calculation != null) {
           
            this.planBreakUpCalculationResponse$.next(_objResponse);
            this.planBreakUpCalculation$.next(
              _objResponse.plan_breakup_calculation
            );
            this.overLappingSubscriptionSignUp$.next(
              _objResponse.overlapping_subscription
            );
            this.initializeDynamicControl(
              _objResponse.plan_breakup_calculation
            );
          } else {
            if (
              _objResponse.overlapping_subscription
                .overlapping_subscription_signup != null
            ) {
              this.errorMessages.push(
                _objResponse.overlapping_subscription
                  .overlapping_subscription_signup.overlapping_errormessage
              );
              this.errorDataModal = this.errorMessages;
              this.showErrorPopup?.next(true);
            } else {
              if (
                _objResponse.overlapping_subscription
                  .overlapping_client_subscription.new_date != null
              ) {
                this.translate
                  .get('POS.MEMBERSHIP_ADDON.OVERLAP_SUBSCRIPTION', {
                    date: this.timeService.formatDate(
                      _objResponse.overlapping_subscription
                        .overlapping_client_subscription.new_date
                        .subs_start_date,
                      'mediumdate'
                    ),
                  })
                  .subscribe((translation) => {
                    this.errorMessages.push(translation);
                    this.errorDataModal = this.errorMessages;
                    this.showErrorPopup?.next(true);
                  });
              } else {
                this.errorMessages.push(
                  _objResponse.overlapping_subscription
                    .overlapping_client_subscription.overlapping_errormessage
                );
                this.errorDataModal = this.errorMessages;
                this.showErrorPopup?.next(true);
              }
            }
          }
        },
        error: (error: AppErrors) => {
          this.errorMessages = [];
          this.handleError(error);
        }
      });
  }

  handleError(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        if (e.identifier == 'OfferMasterCouponCodeLink' || e.identifier == 'CouponCodeValidation') {
          this.error.next(error);
          this.showErrorPopup?.next(true);
        }
        else {
          this.error.next(error);
          this.showErrorPopup?.next(true);
        }
      });
    } else {
      this.error.next(error);
      this.showErrorPopup?.next(true);
    }
  }

  SaveCharges(paymentObject: any) {
    let paymentSignUp: PaymentSignUp = {} as PaymentSignUp;
    paymentSignUp = paymentObject;
    const chargeCreateRequest = this.buildChargeCreateRequest(true, paymentSignUp);
     this.isSubmitting = true;
     this.plansubscriptionService.CreateCharge(this.tenantId, this.clientId, chargeCreateRequest)
     .pipe(
      retryWhen(errors =>
        errors.pipe(
          // Check for the specific error condition that should trigger a retry
          scan((count, error) => {
            if (
              count < 2 && // Retry only 2 times
              error?.originalError.error?.[0] &&
              error.originalError.error[0].errorCode === 'paymentamountgreaterthaninvoiceamount'
            ) {
              // Update the payload before retrying
              chargeCreateRequest.offline_payment.amount_in_minor_currency = chargeCreateRequest.offline_payment.rounded_amount_in_minor_currency!;
              return count + 1; // Increment the retry count
            }
            // Do not retry for other errors or after 3 retries
            throw error;
          }, 0),
          switchMap((retryCount) => timer(100))
        )
      ),
      catchError((error) => {
        return throwError(error);
      })
     ).subscribe({
        next: (_objResponse: ClientOrderResponse) => {
          this.isSubmitting = false;
          this.clientSignupUUID = _objResponse.charges_link_uuid;
          this.otherPaymentsModal$.next(false);
          this.closeBillingSideBar(_objResponse.charges_link_uuid);
        },
        error: (error) => {
          this.isSubmitting = false;
          this.showChargeOrderError(error);
        }
      });
  }

  private buildChargeCreateRequest(
    isOfflinePayment: boolean,
    paymentSignUp: PaymentSignUp
  ): ChargeCreateRequest {
    const chargeCreateRequest = {
      issue_date: this.billDate.value,
      billing_name: this.billingNameFormControl.value
        ? this.billingNameFormControl.value
        : this.clientName,
      collected_at: this.loggedInTenantId,
      is_offline_payment: isOfflinePayment,
      offline_payment: paymentSignUp,
      is_coupon_code_applied: false,
      sigup_coupon_code: '',
      sales_rep: this.billingOwner.value.id,
      charging_today: {} as ChargingTodaySignUp,
      charging_recurring: {} as RecurringSignUp,
      pos_device_sale: this.posDeviceSale,
    } as ChargeCreateRequest;

    const breakup = this.planBreakUpCalculation$.getValue() as PlanBreakUpCalculation;
    chargeCreateRequest.charging_today = breakup.charging_today;
    chargeCreateRequest.charging_recurring = breakup.charging_recurring;

    if (
      chargeCreateRequest.charging_today?.signup_charges &&
      chargeCreateRequest.charging_today.signup_charges.length > 0
    ) {
      chargeCreateRequest.charging_today.signup_charges.forEach((charge) => {
        charge.discount_reason = this.ChargesDiscountReason.value;
      });
    }

    return chargeCreateRequest;
  }

  PosDeviceCharge(): void {
    if (this.inValidDiscount) return;

    this.fg.markAllAsTouched();

    if (this.billingOwner.invalid) {
      this.cd.detectChanges();
      return;
    }

    this.posGatewaysLoaded = false;
    this.showDeviceList = true;
    this.cd.detectChanges();

    this.loadPaymentGatewaysForPos().subscribe({
      next: () => {
        this.posGatewaysLoaded = true;
        this.cd.detectChanges();
      },
      error: (error) => {
        this.toastMessageService.showError(error);
        this.showDeviceList = false;
        this.posGatewaysLoaded = false;
        this.cd.detectChanges();
      },
    });
  }

  private loadPaymentGatewaysForPos() {
    if (this.stateService.getPaymentGatewayList().length > 0) {
      this.paymentGatewayList.next(this.stateService.getPaymentGatewayList());
      return of(this.stateService.getPaymentGatewayList());
    }

    return this.paymentGatewayMasterService
      .getPaymentGatewayMasters(this.tenantId)
      .pipe(
        map((res) => {
          const items = res.items ?? [];
          this.paymentGatewayList.next(items);
          this.stateService.setPaymentGatewayList(items);
          return items;
        })
      );
  }

  private resolvePaymentGatewayForTerminal(
    terminal: PosTerminal
  ): PaymentGatewatMaster | undefined {
    return this.paymentGatewayList.value.find(
      (gateway) => gateway.id === terminal.pgwconfmst_id
    );
  }

  private proceedWithPosTerminal(terminal: PosTerminal): void {
    const gateway = this.resolvePaymentGatewayForTerminal(terminal);
    if (!gateway) {
      this.toastMessageService.showErrorMessage(
        'Required payment gateway is not configured'
      );
      this.isSubmitting = false;
      this.cd.detectChanges();
      return;
    }

    this.blockPaymentTimeline = false;
    this.paymentGateway = gateway;
    const device: PosDeviceSale = {} as PosDeviceSale;
    device.merchant_id = gateway.merchant_id;
    device.payment_gateway_supported = gateway.payment_gateway;
    device.sale_device_id = terminal.terminal_id;
    this.posDeviceSale = device;
    this.pendingPaymentConfirmation = true;
    this.transactionInProcess = true;
    this.SaveChargesViaPos();
  }

  closeDevicesPopup(event: PosDeviceListCloseEvent): void {
    this.showDeviceList = false;
    this.posGatewaysLoaded = false;

    if (event.selectedDevice) {
      this.proceedWithPosTerminal(event.selectedDevice);
    } else if (event.emptyList) {
      this.toastMessageService.showErrorMessage('No device configured');
      this.isSubmitting = false;
    } else {
      this.isSubmitting = false;
    }

    this.cd.detectChanges();
  }

  closePaymentFailed(): void {
    this.paymentFailed = false;
    this.paymentFailedMessages = [];
    this.posDeviceSale = undefined;
    this.pendingPaymentConfirmation = false;
    this.blockPaymentTimeline = true;
    this.clientSignupUUID = '';
    this.cd.detectChanges();
  }

  RetryPayment(): void {
    this.paymentFailed = false;
    this.paymentFailedMessages = [];
    this.blockPaymentTimeline = false;
    this.transactionInProcess = true;

    if (this.selectedCardOnFileTokenId) {
      this.SaveChargesOnline({} as PaymentSignUp, this.selectedCardOnFileTokenId);
    } else {
      this.SaveChargesViaPos();
    }
  }

  private SaveChargesViaPos(): void {
    const chargeCreateRequest = this.buildChargeCreateRequest(
      false,
      {} as PaymentSignUp
    );
    this.isSubmitting = true;

    this.plansubscriptionService
      .CreateCharge(this.tenantId, this.clientId, chargeCreateRequest)
      .subscribe({
        next: (response: ClientOrderResponse) => {
          this.isSubmitting = false;
          this.clientSignupUUID = response.charges_link_uuid;
          this.otherPaymentsModal$.next(false);

          if (this.shouldConfirmPaymentAfterApi()) {
            this.handlePaymentConfirmation(response.charges_link_uuid, {
              paymentTimeoutMs: this.POS_PAYMENT_TIMEOUT_MS,
              requireOnlinePaymentStatus: this.isCardOnFilePaymentConfirmation(),
            });
            return;
          }

          this.transactionInProcess = false;
          this.closeBillingSideBar(response.charges_link_uuid);
        },
        error: (error) => {
          this.isSubmitting = false;
          this.showChargeOrderError(error);
        },
      });
  }

  private showChargeOrderError(error: AppErrors): void {
    const messages = extractApiErrorMessages(error);

    if (this.transactionInProcess) {
      this.transactionInProcess = false;
      this.paymentFailedMessages = messages;
      this.paymentFailed = true;
      this.blockPaymentTimeline = true;
      this.clientSignupUUID = '';
    } else {
      this.transactionInProcess = false;
      this.paymentFailed = false;
      this.error.next(error);
      this.errorMessages = messages;
      this.showErrorPopup?.next(true);
      this.otherPaymentsModal$.next(false);
    }
    this.cd.detectChanges();
  }

  initializeDynamicControl(_objResponse: PlanBreakUpCalculation) {
    const fg: UntypedFormGroup = new UntypedFormGroup({});
    _objResponse.charging_today.signup_charges.forEach(
      (value: ChargeBreakUp) => {
        fg.addControl(
          'chargesbasecost_' + value.id.toString(),
          new UntypedFormControl(value.amount_in_minor_currency, [
            Validators.required,
          ])
        );
        fg.addControl(
          'charges_' + value.id.toString(),
          new UntypedFormControl(
            this.commonService.ConvertAmountFromMinorCurrency(
              this.getChargeNetCost(value)
            ),
            [Validators.required]
          )
        );
        fg.addControl(
          'discount_' + value.id.toString(),
          new UntypedFormControl(
            value.discount_amt_in_minor_currency,
            Validators.required
          )
        );
      }
    );
    this.charges.push(fg);

    // Handle products form controls
    if (_objResponse.charging_today.products && _objResponse.charging_today.products.length > 0) {
      const productsFormGroup: UntypedFormGroup = new UntypedFormGroup({});
      _objResponse.charging_today.products.forEach(
        (value: any) => {
          productsFormGroup.addControl(
            'productbasecost_' + value.sku_id.toString(),
            new UntypedFormControl(value.base_cost_in_minor_currency, [
              Validators.required
            ])
          );
          productsFormGroup.addControl(
            'product_' + value.sku_id.toString(),
            new UntypedFormControl(
              this.commonService.ConvertAmountFromMinorCurrency(
                this.getProductNetCost(value)
              ),
              [Validators.required]
            )
          );
          productsFormGroup.addControl(
            'productdiscount_' + value.sku_id.toString(),
            new UntypedFormControl(
              value.discount_amt_in_minor_currency,
              Validators.required
            )
          );
        }
      );

      if (this.products.controls.length > 0) {
        this.products.clear();
      }
      this.products.push(productsFormGroup);
      this.products.updateValueAndValidity();
    }

  }

  calculateDiscount(
    basePriceCtrl: UntypedFormControl,
    amtCtrl: UntypedFormControl,
    disCtrl: UntypedFormControl
  ) {
    let lineItemChargeAmount = 0;
    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(
      basePriceCtrl.value
    );
    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      amtCtrl.value &&
      lineItemChargeAmount >= amtCtrl.value
    ) {
      disCtrl.setValue(100 - (amtCtrl.value * 100) / lineItemChargeAmount); // set discount
      //this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtCtrl.setValue(lineItemChargeAmount);
        disCtrl.setValue(0);
        //this.inValidDiscount = true;
      }, 10);
    }
  }

  calculateAmount(
    basePriceCtrl: UntypedFormControl,
    amtCtrl: UntypedFormControl,
    disCtrl: UntypedFormControl
  ) {
    let lineItemChargeAmount: number = basePriceCtrl.value;
    lineItemChargeAmount =
      this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    const netValue = lineItemChargeAmount - (lineItemChargeAmount * disCtrl.value) / 100;
    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      netValue
    ) {
      amtCtrl.setValue(netValue);
      //this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;

        amtCtrl.setValue(lineItemChargeAmount);
        disCtrl.setValue(0);
        //this.inValidDiscount = true;
      }, 10);
    }
  }


  //#region ordinal_suffix_of
  ordinal_suffix_of(i: any) {
    const j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + 'st';
    }
    if (j == 2 && k != 12) {
      return i + 'nd';
    }
    if (j == 3 && k != 13) {
      return i + 'rd';
    }
    return i + 'th';
  }
  
  getTotalBaseCost(serviceBreakUp: ServiceBreakUp[]): number {
    return serviceBreakUp?.reduce(function (acc, obj) {
      return acc + obj.base_cost_in_minor_currency;
    }, 0);
  }

  getTotal(serviceBreakUp: ServiceBreakUp[]): string {
    return serviceBreakUp
      .reduce(function (acc, obj) {
        return acc + obj.taxable_cost_in_minor_currency;
      }, 0)
      .toString();
  }

  getTotalTaxAmount(serviceBreakUp: ServiceBreakUp[]): number {
    let taxAmount = 0;
    serviceBreakUp?.forEach((value: ServiceBreakUp) => {
      if (value.tax)
        taxAmount =
          taxAmount +
          value.tax.reduce(function (acc, obj) {
            return acc + obj.amt_in_minor_currency;
          }, 0);
    });

    return taxAmount;
  }

  getTaxAmount(tax: TaxLineItemBreakUp[]): number {
    let taxAmount = 0;
    if (tax)
      taxAmount = tax.reduce(function (acc, obj) {
        return acc + obj.amt_in_minor_currency;
      }, 0);
    return taxAmount;
  }

  getTotalChargeTaxAmount(charge: ChargeBreakUp[]): number {
    let taxAmount = 0;
    charge.forEach((value: ChargeBreakUp) => {
      if (value.tax != null)
        taxAmount =
          taxAmount +
          value.tax.reduce(function (acc, obj) {
            return acc + obj.amt_in_minor_currency;
          }, 0);
    });
    return taxAmount;
  }

  getTotalProductTaxAmount(product: BillingRetailProduct[]): number {
    let taxAmount = 0;
    product.forEach((value: BillingRetailProduct) => {
      if (value.tax != null)
        taxAmount = taxAmount + value.tax.reduce(function (acc, obj) {
          return acc + obj.amt_in_minor_currency;
        }, 0);
    });
    return taxAmount;
  }



  formatDate(date: Date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  clientStatus(client: any): string {
    if (client?.client_status)
      return this.clientService.getClientStatusHtml(client.client_status.toString());
    else return '';
  }

  // TrackBy function for product list performance
  trackByProductId(index: number, item: any): number {
    return item.sku_id || index;
  }

  RequestAccess() {
    const reportRequestAccess = {
      claim: ClaimConstant.can_admin_billing,
      access_requested_friendly_name: ClaimConstant.can_admin_billing,
      request_access_comment: 'Claim Acess for Billing',
    };

    this.staffService.RequestAccess(reportRequestAccess, this.tenantId).subscribe({
      next: () => {
        this.translate
          .get('STAFF.ACCESS.REQUEST_SUCCESS')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
      },
      error: (error) => {
        if (error instanceof NotFoundError) {
          this.translate
            .get('REPORTS.ERROR_MSG.ERROR')
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation);
            });
        } else {
          this.translate
            .get('STAFF.ACCESS.REQUEST_FAILED')
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation);
            });
        }
      },
    });
  }


  getProductSKuDetails(productId: number): any {
    return this.posDetails?.subscriptionProductsAndCharges?.products.find(p => p.sku_id === productId)?.product_sku;
  }


  OpenOfflinePayment() {
    // Check if we have products that need fulfillment confirmation
    if (this.hasProductsToFulfill()) {
      this.productFulfillmentItems = this.prepareProductFulfillmentItems();
      this.showProductFulfillmentPopup = true;
      // Reset submitting state since we're showing popup instead of processing
      this.isSubmitting = false;
      return;
    }

    // If no products, proceed with normal flow
    this.totalBalance$.next(this.chargeMaster.amount_in_minor_currency);
    this.otherPaymentsModal$.next(true);
  }

  OpenOnlinePayment(): void {
    this.isSubmitting = true;
    this.SaveChargesOnline({} as PaymentSignUp);
  }

  OpenSavedPaymentMethods(): void {
    this.showSavedPaymentMethodsPopup.next(true);
    this.cd.markForCheck();
  }

  onSavedPaymentMethodSelected(tokenId: number): void {
    this.selectedCardOnFileTokenId = tokenId;
    this.pendingPaymentConfirmation = true;
    this.showSavedPaymentMethodsPopup.next(false);
    this.isSubmitting = true;
    this.transactionInProcess = true;
    this.SaveChargesOnline({} as PaymentSignUp, tokenId);
  }

  onSavedPaymentMethodsPopupClosed(): void {
    this.showSavedPaymentMethodsPopup.next(false);
    if (
      !this.transactionInProcess &&
      !this.paymentConfirmationPending &&
      !this.pendingPaymentConfirmation
    ) {
      this.selectedCardOnFileTokenId = null;
    }
    this.cd.markForCheck();
  }

  private SaveChargesOnline(paymentObject: PaymentSignUp, cardOnFileTokenId?: number): void {
    const chargeCreateRequest = {
      issue_date: this.billDate.value,
      billing_name: this.billingNameFormControl.value ? this.billingNameFormControl.value : this.clientName,
      collected_at: this.loggedInTenantId,
      is_offline_payment: false,
      offline_payment: {} as PaymentSignUp,
      is_coupon_code_applied: false,
      sigup_coupon_code: '',
      sales_rep: this.billingOwner.value?.id ?? 0,
      charging_today: {} as ChargingTodaySignUp,
      charging_recurring: {} as RecurringSignUp,
    } as ChargeCreateRequest & { card_on_file_token_id?: number };

    if (cardOnFileTokenId) {
      chargeCreateRequest.card_on_file_token_id = cardOnFileTokenId;
    }

    const _objResponse = this.planBreakUpCalculation$.getValue() as PlanBreakUpCalculation;
    chargeCreateRequest.charging_today = _objResponse.charging_today;
    chargeCreateRequest.charging_recurring = _objResponse.charging_recurring;

    this.isSubmitting = true;
    this.plansubscriptionService.CreateCharge(this.tenantId, this.clientId, chargeCreateRequest)
      .pipe(
        catchError((error) => throwError(error))
      )
      .subscribe({
        next: (_response: ClientOrderResponse) => {
          this.isSubmitting = false;
          this.clientSignupUUID = _response.charges_link_uuid;

          if (this.shouldConfirmPaymentAfterApi()) {
            this.handlePaymentConfirmation(_response.charges_link_uuid, {
              requireOnlinePaymentStatus: this.isCardOnFilePaymentConfirmation(),
            });
            return;
          }

          this.transactionInProcess = false;
          this.closeBillingSideBar(_response.charges_link_uuid, false);
        },
        error: (error) => {
          this.isSubmitting = false;
          this.showChargeOrderError(error);
        }
      });
  }

  closeDialog(): void {
    this.showErrorPopup?.next(false);
  }

  AddToCart() {
    const chargeObject:any = {};
    const chargeBreakUpCalculationRequest: ChargeBreakUpCalculationRequest = {
      client_id: this.clientId,
      coupon_code: '',
      is_coupon_code_applied: false,
      issue_date: this._issueDate
    };
    this.otherPaymentsModal$.next(false);
    this.closeBillingSideBar("");

    chargeObject.chargeDetails = this.posDetails;
    this.getchargesTotalOneTimeCost$.subscribe((totalOneTimeCost) => {
      chargeObject.totalAmount = totalOneTimeCost;
      chargeObject.chargeBreakUpCalculationRequest = chargeBreakUpCalculationRequest;
      chargeObject.origionalData = this.chargeMaster;
      chargeObject.billingName = this.billingNameForm.value.billing_name;
      this.addToCart.emit({type: 'charge', object: chargeObject});
    });
    
  }

  HideOtherPaymentDialog(evt: any) {
    this.otherPaymentsModal$.next(false);

    if (evt?.paymentSignUp) {
      // Defer save so the dialog can close before the click reaches buttons behind it.
      setTimeout(() => {
        this.SaveCharges(evt.paymentSignUp);
      }, 0);
    }
  }

  closeOtherPaymentDialog(event:any)
  {
    this.otherPaymentsModal$.next(false);
  }

  get netCost$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          const _value = value.plan_breakup_calculation.charging_today.service_first_charge.services?.reduce(
            (acc, obj) => {
              return (
                acc +
                this.getNetCost(
                  obj.taxable_cost_in_minor_currency,
                  this.getTaxAmount(obj.tax)
                )
              );
            },
            0
          );
          return _value;
        } else {
          return 0;
        }
      })
    );
  }

  get nonRecurringNetCost$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value?.plan_breakup_calculation.charging_today.service_non_recurring.services && value.plan_breakup_calculation.charging_today.service_non_recurring.services.length > 0) {
          return value.plan_breakup_calculation.charging_today.service_non_recurring.services.reduce(
             (acc, obj) => {
              return (
                acc +
                this.getNetCost(
                  obj.taxable_cost_in_minor_currency,
                  this.getTaxAmount(obj.tax)
                )
              );
            },
            0
          );
        } else return 0;
      })
    );
  }

  getChargesNetCost(taxableAmount: number, taxAmount: number): number {
    return this.isInclusive ? taxableAmount + taxAmount : taxableAmount;
  }

  getNetCost(taxableAmount: number, taxAmount: number): number {
    return this.isInclusive ? taxableAmount + taxAmount : taxableAmount;
  }

  getChargeNetCost(charge: ChargeBreakUp): number {
    return this.getNetCost(
      charge.taxable_cost_in_minor_currency,
      this.getTaxAmount(charge.tax)
    );
  }

  getProductNetCost(product: any): number {
    return this.getNetCost(
      product.taxable_cost_in_minor_currency,
      this.getTaxAmount(product.tax)
    );
  }

  /** Product line total including tax (for exclusive tax display). */
  getProductLineTotal(product: BillingRetailProduct): number {
    return product.taxable_cost_in_minor_currency + this.getTaxAmount(product.tax);
  }

  get charges(): UntypedFormArray {
    return this.fgProducts.get('charges') as UntypedFormArray;
  }

  get products(): UntypedFormArray {
    return this.fgProducts.get('products') as UntypedFormArray;
  }

  getProductControls(controlName: string) {
    const productControls = this.fgProducts.controls.products as any;
    if (productControls?.controls && productControls.controls.length > 0) {
      return productControls.controls[0].get(controlName) as UntypedFormControl;
    }
    return null;
  }

  get hasbillingRights(): boolean {
    return (
      this.currentUserDetails.role.toLowerCase() == 'admin' ||
      this.currentUserDetails.role == Roles.Admin ||
      this.currentUserDetails.role.toString() == Roles[Roles.Admin] ||
      this.currentUserDetails.can_do_billing === 'true'
    );
  }


  //#region firstTimeAmount
  get firstTimeAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmFirstTimeAmt as UntypedFormControl;
  }

  get firstTimeAmount(): number {
    return this.firstTimeAmountFormControl.value as number;
  }

  set firstTimeAmount(val: number) {
    this.firstTimeAmountFormControl.setValue(val);
  }

  get firstTimeTaxAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmFirstTimeTaxAmt as UntypedFormControl;
  }

  get firstTimeTaxAmount(): number {
    return this.firstTimeTaxAmountFormControl.value as number;
  }

  set firstTimeTaxAmount(val: number) {
    this.firstTimeTaxAmountFormControl.setValue(val);
  }

  get firstTimeDiscountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmFirstTimeDis as UntypedFormControl;
  }

  get firstTimeDiscount(): number {
    return this.firstTimeDiscountFormControl.value as number;
  }

  set firstTimeDiscount(val: number) {
    this.firstTimeDiscountFormControl.setValue(val);
  }

  //#endregion firstTimeAmount

  //#region nonRecurringAmount

  get nonRecurringAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmNonRecurringAmt as UntypedFormControl;
  }

  get nonRecurringAmount(): number {
    return this.nonRecurringAmountFormControl.value as number;
  }

  set nonRecurringAmount(val: number) {
    this.nonRecurringAmountFormControl.setValue(val);
  }

  get nonRecurringTaxAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmNonRecurringTaxAmt as UntypedFormControl;
  }

  get nonRecurringTaxAmount(): number {
    return this.nonRecurringTaxAmountFormControl.value as number;
  }

  set nonRecurringTaxAmount(val: number) {
    this.nonRecurringTaxAmountFormControl.setValue(val);
  }

  get nonRecurringDiscountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmNonRecurringDis as UntypedFormControl;
  }

  get nonRecurringDiscount(): number {
    return this.nonRecurringDiscountFormControl.value as number;
  }

  set nonRecurringDiscount(val: number) {
    this.nonRecurringDiscountFormControl.setValue(val);
  }

  //#endregion nonRecurringAmount

  //#region RecurringAmount

  //#region "getproperty"
  get planList() {
    return this.fg.controls.ddlplanSubscriptionList as UntypedFormControl;
  }

  /** Cart summary card: charge picker and/or pre-breakup line items. Hidden when charge is pre-selected and cart is empty. */
  get showCartSummaryCard(): boolean {
    if (this.disableChargeMasterDropdown) {
      return true;
    }
    const products = this.posDetails?.subscriptionProductsAndCharges?.products;
    const breakupProducts =
      this.planBreakUpCalculationResponse$.value?.plan_breakup_calculation?.charging_today?.products;
    return (products?.length ?? 0) > 0 && !(breakupProducts?.length);
  }

  get billingCycle() {
    return this.fg.controls.ddlBillingCycle as UntypedFormControl;
  }

  get billCycle() {
    return this.billingCycle.value;
  }

  get billingOwner() {
    return this.fg.controls.billingOwner as UntypedFormControl;
  }

  get billDate() {
    return this.fg.controls.billdate as UntypedFormControl;
  }

  get subscriptionStartdate() {
    return this.fg.controls.subscriptionstartdate as UntypedFormControl;
  }

  get couponCodeFormControl() {
    return this.fg.controls.couponCode as UntypedFormControl;
  }

  get couponCodeFormControlValue() {
    return this.couponCodeFormControl.value;
  }

  get ChargesDiscountReason(): UntypedFormControl {
    return this.fgProducts.controls.charges_reason as UntypedFormControl;
  }



  get totalOneTimeCost$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          let firstChargeCost: number = 0;
          let firstChargeTaxCost: number = 0;
          let nonRecurringChargeCost: number = 0;
          let nonRecurringTaxChargeCost: number = 0;
          let chargeCost: number = 0;
          let chargeTaxCost: number = 0;
          let productCost: number = 0;
          let productTaxCost: number = 0;
          if (value?.plan_breakup_calculation) {
            if (value.plan_breakup_calculation.charging_today.service_first_charge?.services
            ) {
              firstChargeCost =
                value.plan_breakup_calculation.charging_today.service_first_charge.services.reduce(
                  function (acc, obj) {
                    return acc + obj.taxable_cost_in_minor_currency;
                  },
                  0
                );
            }

            if (value.plan_breakup_calculation.charging_today.service_first_charge?.services) {
              firstChargeTaxCost = this.getTotalTaxAmount(
                value.plan_breakup_calculation.charging_today
                  .service_first_charge.services
              );
            }
            if (value.plan_breakup_calculation.charging_today.service_non_recurring?.services) {
              nonRecurringChargeCost =
                value.plan_breakup_calculation.charging_today.service_non_recurring.services.reduce(
                  function (acc, obj) {
                    return acc + obj.taxable_cost_in_minor_currency;
                  },
                  0
                );
            }

            if (value.plan_breakup_calculation.charging_today.service_non_recurring?.services) {
              nonRecurringTaxChargeCost = this.getTotalTaxAmount(
                value.plan_breakup_calculation.charging_today
                  .service_non_recurring.services
              );
            }

            chargeCost =
              value.plan_breakup_calculation.charging_today.signup_charges.reduce(
                function (acc, obj) {
                  return acc + obj.taxable_cost_in_minor_currency;
                },
                0
              );

            chargeTaxCost = this.getTotalChargeTaxAmount(
              value.plan_breakup_calculation.charging_today.signup_charges
            );
            if (value.plan_breakup_calculation.charging_today.products && value.plan_breakup_calculation.charging_today.products.length > 0) {
              productCost = value.plan_breakup_calculation.charging_today.products.reduce(
                function (acc, obj) {
                  return acc + obj.taxable_cost_in_minor_currency;
                },
                0
              );
              productTaxCost = this.getTotalProductTaxAmount(
                value.plan_breakup_calculation.charging_today.products
              );
            }
          }
          const _value =
            (
              firstChargeCost +
              firstChargeTaxCost +
              nonRecurringChargeCost +
              nonRecurringTaxChargeCost +
              chargeCost +
              chargeTaxCost +
              productCost +
              productTaxCost
            );

          return (_value == 0) ? 0.00000001 : _value;

        } else return 0;
      })
    );
  }

  get getchargesTotalOneTimeCost$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          let firstChargeCost: number = 0;
          let firstChargeTaxCost: number = 0;
          let nonRecurringChargeCost: number = 0;
          let nonRecurringTaxChargeCost: number = 0;
          let chargeCost: number = 0;
          let chargeTaxCost: number = 0;
          if (value?.plan_breakup_calculation) {
            if (value.plan_breakup_calculation.charging_today.service_first_charge?.services
            ) {
              firstChargeCost =
                value.plan_breakup_calculation.charging_today.service_first_charge.services.reduce(
                  function (acc, obj) {
                    return acc + obj.taxable_cost_in_minor_currency;
                  },
                  0
                );
            }

            if (value.plan_breakup_calculation.charging_today.service_first_charge?.services) {
              firstChargeTaxCost = this.getTotalTaxAmount(
                value.plan_breakup_calculation.charging_today
                  .service_first_charge.services
              );
            }
            if (value.plan_breakup_calculation.charging_today.service_non_recurring?.services) {
              nonRecurringChargeCost =
                value.plan_breakup_calculation.charging_today.service_non_recurring.services.reduce(
                  function (acc, obj) {
                    return acc + obj.taxable_cost_in_minor_currency;
                  },
                  0
                );
            }

            if (value.plan_breakup_calculation.charging_today.service_non_recurring?.services) {
              nonRecurringTaxChargeCost = this.getTotalTaxAmount(
                value.plan_breakup_calculation.charging_today
                  .service_non_recurring.services
              );
            }

            chargeCost =
              value.plan_breakup_calculation.charging_today.signup_charges.reduce(
                function (acc, obj) {
                  return acc + obj.taxable_cost_in_minor_currency;
                },
                0
              );

            chargeTaxCost = this.getTotalChargeTaxAmount(
              value.plan_breakup_calculation.charging_today.signup_charges
            );
            
          }
          const _value =
            (
              firstChargeCost +
              firstChargeTaxCost +
              nonRecurringChargeCost +
              nonRecurringTaxChargeCost +
              chargeCost +
              chargeTaxCost
            );

          return (_value == 0) ? 0.00000001 : _value;

        } else return 0;
      })
    );
  }


  get recurringCost$(): Observable<number> {
    return this.planBreakUpCalculation$.pipe(
      map((value: PlanBreakUpCalculation | null) => {
        if (value) {
          return value.charging_recurring.services.reduce( (acc, obj) => acc + obj.taxable_cost_in_minor_currency + this.getTaxAmount(obj.tax), 0);
        } else return 0;
      })
    );
  }

  getChargeAmount(chargeId: number) {
    const charge = this.planBreakUpCalculation$.value?.charging_today.signup_charges || [];
    const chargeDetails = charge.find(o => o.id == chargeId);
    return (chargeDetails?.taxable_cost_in_minor_currency || 0) + this.getTaxAmount(chargeDetails?.tax || []);
  }

  getChargeMasterAmount(charge: ChargeMaster | null | undefined): number {
    return charge?.amount_in_minor_currency ?? 0;
  }

  ApplyDiscount(value: any) {
    if (this.couponApplied) {
      this.alreadyDiscountApplied.next(true);
      this.applyDiscount = false;
    } else {
      this.applyDiscount = true;
      this.alreadyDiscountApplied.next(false);
      this.ChargesDiscountReason.addValidators([Validators.required]);
    }
  }


  calculateChargeDiscount(
    lineItemChargeAmount: number,
    amtCtrl: string,
    disCtrl: string
  ) {
    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);

    const amtControl: any = ((this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    const disControl: any = ((this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      amtControl.value &&
      lineItemChargeAmount >= amtControl.value
    ) {
      disControl.setValue(
        100 - (amtControl.value * 100) / lineItemChargeAmount
      ); // set discount
      this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;

        amtControl.setValue(lineItemChargeAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
      }, 10);
    }
  }

  calculateChargeAmount(
    lineItemChargeAmount: number,
    amtCtrl: string,
    disCtrl: string
  ) {
    const amtControl: any = (
      (this.fgProducts.controls.charges as UntypedFormArray)
        .controls[0] as UntypedFormGroup
    ).controls[amtCtrl];
    const disControl: any = (
      (this.fgProducts.controls.charges as UntypedFormArray)
        .controls[0] as UntypedFormGroup
    ).controls[disCtrl];

    lineItemChargeAmount =
      this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    const netValue =
      lineItemChargeAmount - (lineItemChargeAmount * disControl.value) / 100;

    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      netValue
    ) {
      amtControl.setValue(netValue);
      this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemChargeAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
      }, 10);
    }
  }

  calculateProductDiscount(lineItemProductAmount: number, amtCtrl: string, disCtrl: string) {
    lineItemProductAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemProductAmount);
    const amtControl: any = ((this.fgProducts.controls.products as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    const disControl: any = ((this.fgProducts.controls.products as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    if (lineItemProductAmount - (lineItemProductAmount * this.single_staff_discount) / 100 <= amtControl.value && lineItemProductAmount >= amtControl.value) {
      disControl.setValue(100 - (amtControl.value * 100) / lineItemProductAmount);
      this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemProductAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
      }, 10);
    }
  }

  calculateProductAmount(lineItemProductAmount: number, amtCtrl: string, disCtrl: string) {
    const amtControl: any = ((this.fgProducts.controls.products as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    const disControl: any = ((this.fgProducts.controls.products as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    lineItemProductAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemProductAmount);
    const netValue = lineItemProductAmount - (lineItemProductAmount * disControl.value) / 100;

    if (lineItemProductAmount - (lineItemProductAmount * this.single_staff_discount) / 100 <= netValue) {
      amtControl.setValue(netValue);
      this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemProductAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
      }, 10);
    }
  }


  closeBillingSideBar(
    sGuid: string,
    isPayment: boolean = true,
    options?: { skipPaymentPolling?: boolean }
  ) {
    if (this.isPaymentFlowBlockingUi) {
      return;
    }

    const shouldSuppressTimeline = this.blockPaymentTimeline;
    const orderUuid = shouldSuppressTimeline ? '' : this.clientSignupUUID || sGuid;

    this.closeSidePopup.emit({
      hideSidebar: false,
      clientSignupUUID: orderUuid,
      ispayment: isPayment,
      skipPaymentPolling: options?.skipPaymentPolling ?? false,
      suppressPaymentTimeline: shouldSuppressTimeline,
    });
  }

  onBillingSidebarHide(): void {
    if (this.isPaymentFlowBlockingUi) {
      return;
    }

    this.closeBillingSideBar('');
  }

  get isPaymentFlowBlockingUi(): boolean {
    return this.transactionInProcess || this.paymentConfirmationPending;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKeyDuringPayment(event: Event): void {
    if (this.paymentConfirmationTimedOut) {
      event.preventDefault();
      this.closePaymentConfirmationTimeout();
      return;
    }

    if (this.isPaymentFlowBlockingUi) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  private handlePaymentConfirmation(
    orderUuid: string,
    options?: { paymentTimeoutMs?: number; requireOnlinePaymentStatus?: boolean }
  ): void {
    combineLatest([
      this.store.select(COMPANY_INFO),
      this.store.select(TENANTS_INFO),
    ])
      .pipe(
        take(1),
        filter(
          ([companyInfo, tenantInfo]) =>
            !!companyInfo?.compDetails?.uuid &&
            !!tenantInfo?.selected_tenant?.tenant_uuid
        )
      )
      .subscribe(([companyInfo, tenantInfo]) => {
        const requireOnlinePaymentStatus =
          options?.requireOnlinePaymentStatus ?? false;

        this.transactionInProcess = false;
        this.paymentConfirmationPending = true;
        this.paymentConfirmationTimedOut = false;
        this.paymentConfirmationOrderUuid = orderUuid;
        this.paymentConfirmationPosFlow = !!options?.paymentTimeoutMs;
        this.pendingPaymentConfirmation = true;
        this.paymentConfirmationShowTimeLimit = !!options?.paymentTimeoutMs;
        if (options?.paymentTimeoutMs) {
          this.startPaymentConfirmationCountdown(options.paymentTimeoutMs);
        } else {
          this.paymentConfirmationSecondsRemaining = 0;
        }
        this.cd.detectChanges();

        this.orderSubscriptionStatusPollingService.pollSignupPaymentUntilTerminal({
          companyUuid: companyInfo.compDetails.uuid,
          tenantUuid: tenantInfo.selected_tenant.tenant_uuid,
          uuid: orderUuid,
          deadlineMs: options?.paymentTimeoutMs,
          requireOnlinePaymentStatus,
          onOutcome: (outcome, response) =>
            this.handlePaymentPollOutcome(outcome, orderUuid, response),
        });
      });
  }

  private handlePaymentPollOutcome(
    outcome: SignupPaymentPollTerminalOutcome,
    orderUuid: string,
    response?: GetOrderStatusOfQuotation
  ): void {
    this.clearPaymentConfirmationCountdown();
    this.paymentConfirmationShowTimeLimit = false;
    this.paymentConfirmationSecondsRemaining = 0;

    if (outcome === 'success') {
      this.paymentConfirmationPending = false;
      this.paymentConfirmationTimedOut = false;
      this.posDeviceSale = undefined;
      this.selectedCardOnFileTokenId = null;
      this.pendingPaymentConfirmation = false;
      this.blockPaymentTimeline = false;
      this.closeBillingSideBar(orderUuid, true, { skipPaymentPolling: true });
    } else if (outcome === 'timeout') {
      this.paymentConfirmationOrderUuid = orderUuid;
      this.paymentConfirmationTimedOut = true;
      this.posDeviceSale = undefined;
      this.pendingPaymentConfirmation = false;
      this.blockPaymentTimeline = true;
      this.clientSignupUUID = '';
    } else {
      this.paymentConfirmationPending = false;
      this.paymentConfirmationTimedOut = false;
      const failureReason = response
        ? getOnlinePaymentFailureReason(response)
        : undefined;

      this.paymentFailedMessages = [
        failureReason || this.translate.instant('POS_DEVICE.FAILED_REASON'),
      ];
      this.pendingPaymentConfirmation = false;
      this.paymentFailed = true;
      this.blockPaymentTimeline = true;
      this.clientSignupUUID = '';
    }

    this.cd.detectChanges();
  }

  closePaymentConfirmationTimeout(): void {
    this.paymentConfirmationPending = false;
    this.paymentConfirmationTimedOut = false;
    this.paymentConfirmationOrderUuid = '';
    this.paymentConfirmationPosFlow = false;
    this.pendingPaymentConfirmation = false;
    this.posDeviceSale = undefined;
    this.blockPaymentTimeline = true;
    this.clientSignupUUID = '';
    this.orderSubscriptionStatusPollingService.stopPolling();
    this.cd.detectChanges();
  }

  get paymentConfirmationTimeoutMessage(): string {
    return this.translate.instant(
      this.paymentConfirmationPosFlow
        ? 'POS_DEVICE.PAYMENT_CONFIRMATION_TIMEOUT_POS'
        : 'POS_DEVICE.PAYMENT_CONFIRMATION_TIMEOUT'
    );
  }

  private startPaymentConfirmationCountdown(durationMs: number): void {
    this.clearPaymentConfirmationCountdown();
    const deadline = Date.now() + durationMs;
    this.paymentConfirmationSecondsRemaining = Math.ceil(durationMs / 1000);

    this.paymentConfirmationCountdownSub = interval(1000).subscribe(() => {
      this.paymentConfirmationSecondsRemaining = Math.max(
        0,
        Math.ceil((deadline - Date.now()) / 1000)
      );
      this.cd.detectChanges();
    });
  }

  private clearPaymentConfirmationCountdown(): void {
    if (this.paymentConfirmationCountdownSub) {
      this.paymentConfirmationCountdownSub.unsubscribe();
      this.paymentConfirmationCountdownSub = undefined;
    }
  }

  get paymentConfirmationCountdownDisplay(): string {
    const totalSeconds = this.paymentConfirmationSecondsRemaining;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  private shouldConfirmPaymentAfterApi(): boolean {
    return (
      !!this.posDeviceSale ||
      this.selectedCardOnFileTokenId !== null ||
      this.pendingPaymentConfirmation
    );
  }

  private isCardOnFilePaymentConfirmation(): boolean {
    return (
      this.selectedCardOnFileTokenId !== null ||
      (this.pendingPaymentConfirmation && !this.posDeviceSale)
    );
  }

  StaffDiscountCancel() {
    this.inValidDiscount = false;
    this.applyDiscount=false;
    this.inValidRecurringDiscount = false;
    this.planBreakUpCalculation$.subscribe(
      (_objResponse: PlanBreakUpCalculation | null) => {
        if (_objResponse) {
          // this.netCost$.subscribe((obj: number) => {
          //   this.firstTimeAmount =
          //     this.commonService.ConvertAmountFromMinorCurrency(obj);
          //   if (
          //     this.getTotalBaseCost(
          //       _objResponse.charging_today.service_first_charge.services
          //     ) -
          //     this.commonService.ConvertMinorCurrencyFromAmount(
          //       this.firstTimeAmount
          //     ) ==
          //     0
          //   ) {
          //     this.firstTimeDiscount = 0;
          //   } else {
          //     this.firstTimeDiscount =
          //       100 -
          //       (this.commonService.ConvertMinorCurrencyFromAmount(
          //         this.firstTimeAmount
          //       ) *
          //         100) /
          //       this.getTotalBaseCost(
          //         _objResponse.charging_today.service_first_charge.services
          //       );
          //   }
          // });

          // this.nonRecurringNetCost$.subscribe((obj: number) => {
          //   this.nonRecurringAmount =
          //     this.commonService.ConvertAmountFromMinorCurrency(obj);

          //   if (
          //     this.getTotalBaseCost(
          //       _objResponse.charging_today.service_non_recurring.services
          //     ) -
          //     this.commonService.ConvertMinorCurrencyFromAmount(
          //       this.nonRecurringAmount
          //     ) ==
          //     0
          //   ) {
          //     this.nonRecurringDiscount = 0;
          //   } else {
          //     this.nonRecurringDiscount =
          //       100 -
          //       (this.commonService.ConvertMinorCurrencyFromAmount(
          //         this.nonRecurringAmount
          //       ) *
          //         100) /
          //       this.getTotalBaseCost(
          //         _objResponse.charging_today.service_non_recurring.services
          //       );
          //   }
          // });



          const frmCharges: UntypedFormGroup = (this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup;
          const controlIds: Array<number> = [];

          Object.keys(frmCharges.controls).forEach((key) => {
            if (
              !controlIds.includes(
                parseInt(key.substring(key.indexOf('_') + 1))
              )
            )
              controlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
          });

          _objResponse.charging_today.signup_charges.forEach(
            (value: ChargeBreakUp) => {
              controlIds.forEach((val) => {
                if (value.id.toString() == val.toString()) {
                  frmCharges.controls['charges_' + val.toString()].setValue(
                    this.commonService.ConvertAmountFromMinorCurrency(
                      this.getChargeNetCost(value)
                    )
                  );
                  if (
                    frmCharges.controls['chargesbasecost_' + val.toString()]
                      .value -
                    this.getChargeNetCost(value) ==
                    0
                  ) {
                    frmCharges.controls['discount_' + val.toString()].setValue(
                      0
                    );
                  } else {
                    frmCharges.controls['discount_' + val.toString()].setValue(
                      100 -
                      (this.getChargeNetCost(value) * 100) /
                      frmCharges.controls[
                        'chargesbasecost_' + val.toString()
                      ].value
                    );
                  }
                }
              });
            }
          );

          // Handle products reset logic
          if (_objResponse.charging_today.products && _objResponse.charging_today.products.length > 0) {
            const frmProducts: UntypedFormGroup = (
              this.fgProducts.controls.products as UntypedFormArray
            ).controls[0] as UntypedFormGroup;
            const productControlIds: Array<number> = [];

            Object.keys(frmProducts.controls).forEach((key) => {
              if (
                !productControlIds.includes(
                  parseInt(key.substring(key.indexOf('_') + 1))
                )
              )
                productControlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
            });

            _objResponse.charging_today.products.forEach(
              (value: any) => {
                productControlIds.forEach((val) => {
                  if (value.sku_id.toString() == val.toString()) {
                    frmProducts.controls['product_' + val.toString()].setValue(
                      this.commonService.ConvertAmountFromMinorCurrency(
                        this.getProductNetCost(value)
                      )
                    );
                    if (
                      frmProducts.controls['productbasecost_' + val.toString()]
                        .value -
                      this.getProductNetCost(value) ==
                      0
                    ) {
                      frmProducts.controls['productdiscount_' + val.toString()].setValue(
                        0
                      );
                    } else {
                      frmProducts.controls['productdiscount_' + val.toString()].setValue(
                        100 -
                        (this.getProductNetCost(value) * 100) /
                        frmProducts.controls[
                          'productbasecost_' + val.toString()
                        ].value
                      );
                    }
                  }
                });
              }
            );
          }
        }
      }
    );
  }

  StaffDiscountBreakup() {

    if (this.ChargesDiscountReason && this.ChargesDiscountReason.invalid) {
      this.ChargesDiscountReason.markAsTouched();
      return;
    }

    this.applyDiscount=false;
    this.discountApplied= true;

    const staffDiscountCalculationRequest = {} as StaffDiscountCalculationRequest;
    const staffDiscountChargeRecurring = {} as StaffDiscountChargeRecurring;
    const staffDiscountChargingTodayRequest = {} as StaffDiscountChargingTodayRequest;
    const staffDiscountSignUpChargeRequest: StaffDiscountSignUpChargeRequest[] = [];

    staffDiscountChargingTodayRequest.service_first_charge = {} as StaffDiscountServiceFirstChargeRequest;
    staffDiscountChargingTodayRequest.service_non_recurring = {} as StaffDiscountServiceNonRecurringRequest;
    staffDiscountChargeRecurring.service_recurring = {} as StaffDiscountServiceRecurringRequest;


    staffDiscountCalculationRequest.client_id = this.clientId;
    staffDiscountCalculationRequest.issue_date = this._issueDate;

    staffDiscountChargingTodayRequest.service_first_charge.discount_amt_in_minor_currency = 0;
    staffDiscountChargingTodayRequest.service_non_recurring.discount_amt_in_minor_currency = 0;
    staffDiscountChargeRecurring.service_recurring.discount_amt_in_minor_currency = 0;

    // if (this.frmFirstTimeBaseCostAmount)
    //   staffDiscountChargingTodayRequest.service_first_charge.discount_amt_in_minor_currency = this.frmFirstTimeBaseCostAmount - Math.round(this.commonService.ConvertMinorCurrencyFromAmount(this.firstTimeAmount));

    // if (this.frmNonRecurringBaseCostAmount)
    //   staffDiscountChargingTodayRequest.service_non_recurring.discount_amt_in_minor_currency = this.frmNonRecurringBaseCostAmount - Math.round(this.commonService.ConvertMinorCurrencyFromAmount(this.nonRecurringAmount));

    staffDiscountCalculationRequest.charging_recurring = staffDiscountChargeRecurring;
    //staffDiscountCalculationRequest.charging_today = staffDiscountChargingTodayRequest;

    const frmCharges: UntypedFormGroup = (this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup;
    const controlIds: Array<number> = [];

    //get charges control id.
    Object.keys(frmCharges.controls).forEach((key) => {
      if (!controlIds.includes(parseInt(key.substring(key.indexOf('_') + 1))))
        controlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
    });

    staffDiscountChargingTodayRequest.signup_charges = [];

    controlIds.forEach((val) => {
      const staffDiscountSignupCharge = {} as StaffDiscountSignUpChargeRequest;
      staffDiscountSignupCharge.id = val;
      staffDiscountSignupCharge.discount_amt_in_minor_currency = frmCharges.controls['chargesbasecost_' + val.toString()].value - Math.round(this.commonService.ConvertMinorCurrencyFromAmount(frmCharges.controls['charges_' + val.toString()].value));

      staffDiscountSignUpChargeRequest.push(staffDiscountSignupCharge);

      //Set Value.
      staffDiscountChargingTodayRequest.signup_charges = staffDiscountSignUpChargeRequest;
    });

    //get product control ids
    const formProducts: UntypedFormGroup = (
      this.fgProducts.controls.products as UntypedFormArray
    ).controls[0] as UntypedFormGroup;
    const productControlIds: Array<number> = [];

    if (formProducts != undefined)
      Object.keys(formProducts.controls).forEach((key) => {
        if (!productControlIds.includes(parseInt(key.substring(key.indexOf('_') + 1))))
          productControlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
      });

    // Initialize products array if it doesn't exist
    if (!staffDiscountChargingTodayRequest.products) {
      staffDiscountChargingTodayRequest.products = [];
    }

    // Process products if they exist and form controls are available
    if (formProducts && productControlIds.length > 0) {
      const _objResponse = this.planBreakUpCalculation$.getValue() as PlanBreakUpCalculation;
      if (_objResponse?.charging_today.products && _objResponse.charging_today.products.length > 0) {
        _objResponse.charging_today.products.forEach((val: any) => {
          const staffDiscountProduct = {} as any; // Using any for now since we don't have the interface
          staffDiscountProduct.sku_id = val.sku_id;
          staffDiscountProduct.quantity = val.quantity;
          staffDiscountProduct.is_plan_sku = val.is_plan_sku;
          staffDiscountProduct.base_cost_in_minor_currency = val.base_cost_in_minor_currency;
          staffDiscountProduct.discount_amt_in_minor_currency = Math.max(0, formProducts.controls['productbasecost_' + val.sku_id].value -
            Math.round(this.commonService.ConvertMinorCurrencyFromAmount(formProducts.controls['product_' + val.sku_id].value)));

          staffDiscountChargingTodayRequest.products.push(staffDiscountProduct);
        });
      }
    }

    staffDiscountCalculationRequest.charging_today = staffDiscountChargingTodayRequest;

    this.plansubscriptionService
      .getStaffDiscountChargeCalculation(
        this.tenantId,
        staffDiscountCalculationRequest
      )
      .subscribe({
        next: (_objResponse: PlanBreakUpCalculationResponse) => {
          this.planBreakUpCalculationResponse$.next(_objResponse);
          this.planBreakUpCalculation$.next(
            _objResponse.plan_breakup_calculation
          );
          this.overLappingSubscriptionSignUp$.next(
            _objResponse.overlapping_subscription
          );
        },
      });
  }

  RemoveDiscount(): void {
    this.alreadyDiscountApplied.next(false);
    this.ChargesDiscountReason.reset();
    this.ChargesDiscountReason.removeValidators(Validators.required);
    const staffDiscountCalculationRequest = {} as StaffDiscountCalculationRequest;
    const staffDiscountChargeRecurring = {} as StaffDiscountChargeRecurring;
    const staffDiscountChargingTodayRequest = {} as StaffDiscountChargingTodayRequest;
    const staffDiscountSignUpChargeRequest: StaffDiscountSignUpChargeRequest[] = [];

    staffDiscountChargingTodayRequest.service_first_charge = {} as StaffDiscountServiceFirstChargeRequest;
    staffDiscountChargingTodayRequest.service_non_recurring = {} as StaffDiscountServiceNonRecurringRequest;
    staffDiscountChargeRecurring.service_recurring = {} as StaffDiscountServiceRecurringRequest;

    staffDiscountCalculationRequest.client_id = this.clientId;
    staffDiscountCalculationRequest.issue_date = this._issueDate;

    staffDiscountChargingTodayRequest.service_first_charge.discount_amt_in_minor_currency = 0;
    staffDiscountChargingTodayRequest.service_non_recurring.discount_amt_in_minor_currency = 0;
    staffDiscountChargeRecurring.service_recurring.discount_amt_in_minor_currency = 0;
    staffDiscountCalculationRequest.charging_recurring = staffDiscountChargeRecurring;

    const frmCharges: UntypedFormGroup = (this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup;
    const controlIds: Array<number> = [];

    //get charges control id.
    Object.keys(frmCharges.controls).forEach((key) => {
      if (!controlIds.includes(parseInt(key.substring(key.indexOf('_') + 1))))
        controlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
    });

    controlIds.forEach((val) => {
      const staffDiscountSignupCharge = {} as StaffDiscountSignUpChargeRequest;
      staffDiscountSignupCharge.id = val;
      staffDiscountSignupCharge.discount_amt_in_minor_currency = 0;
      staffDiscountSignUpChargeRequest.push(staffDiscountSignupCharge);
      //Set Value.
      staffDiscountChargingTodayRequest.signup_charges = staffDiscountSignUpChargeRequest;
      staffDiscountCalculationRequest.charging_today = staffDiscountChargingTodayRequest;
    });

    this.plansubscriptionService.getStaffDiscountChargeCalculation(this.tenantId,staffDiscountCalculationRequest)
      .subscribe({
        next: (_objResponse: PlanBreakUpCalculationResponse) => {
          this.planBreakUpCalculationResponse$.next(_objResponse);
          this.planBreakUpCalculation$.next(
            _objResponse.plan_breakup_calculation
          );
          this.overLappingSubscriptionSignUp$.next(
            _objResponse.overlapping_subscription
          );

          const frmCharges: UntypedFormGroup = (
            this.fgProducts.controls.charges as UntypedFormArray
          ).controls[0] as UntypedFormGroup;

          _objResponse.plan_breakup_calculation.charging_today.signup_charges.forEach(
            (value: ChargeBreakUp, index: number) => {
              frmCharges.controls[
                'chargesbasecost_' + value.id.toString()
              ].setValue(value.amount_in_minor_currency);
              frmCharges.controls['charges_' + value.id.toString()].setValue(
                this.commonService.ConvertAmountFromMinorCurrency(
                  this.getChargeNetCost(value)
                )
              );
              frmCharges.controls['discount_' + value.id.toString()].setValue(
                value.discount_amt_in_minor_currency
              );
            }
          );
        },
        error: (error: any) => {
          this.discountApplied = false;
          this.toastMessageService.showError(error);
        }
      });
  }

  getSettings() {
    const settings = this.advanceSettingService.getAdvanceSettings(
      this.tenantId
    );
    if (settings) {
      settings.subscribe({
        next: (res: any) => {
          if (res.items != null) {

            //tax calculation
            const tax_calculation: any = res.items.find((x: { key: string; }) => x.key.toLowerCase() == "tax_calculation")
            if (tax_calculation != null) {
              if (tax_calculation.value.toLowerCase() == 'inclusive')
                this.isInclusive = true;
            }


            //backdated_billing_setting
            const backdated_billing_setting: any = res.items.find((x: { key: string; }) => x.key.toLowerCase() == "backdated_billing_setting")
            if (backdated_billing_setting != null) {
              if (backdated_billing_setting.value > 0)
                this.minStartDate.setDate(this.minStartDate.getDate() - parseInt(backdated_billing_setting.value));
            }
          }
        },
      });
    }
  }

  get billingNameFormControl(): UntypedFormControl {
    return this.billingNameForm.controls.billing_name as UntypedFormControl;
  }

  removeBillingName() {
    this.billingNameFormControl.setValue('');
  }

  HideErrorPopup() {
    this.errorMessages = [];
    this.errorDataModal = [];
    this.showErrorPopup?.next(false);
  }

  // Product fulfillment popup methods
  private hasProductsToFulfill(): boolean {
    return PosBillingSummaryComponentHelpers.hasProductsToFulfill(this.posDetails);
  }

  private prepareProductFulfillmentItems(): ProductFulfillmentItem[] {
    return PosBillingSummaryComponentHelpers.prepareProductFulfillmentItems(this.posDetails);
  }

  private updateProductFulfillmentStatus(updatedProducts: ProductFulfillmentItem[]): void {
    PosBillingSummaryComponentHelpers.updateProductFulfillmentStatus(this.posDetails, updatedProducts);
  }

  onProductFulfillmentConfirm(updatedProducts: ProductFulfillmentItem[]): void {
    this.updateProductFulfillmentStatus(updatedProducts);
    this.showProductFulfillmentPopup = false;
    
    // Continue with offline payment
    this.proceedWithOfflinePayment();
  }

  onProductFulfillmentCancel(): void {
    this.showProductFulfillmentPopup = false;
    // Reset submitting state when popup is cancelled
    this.isSubmitting = false;
  }

  private proceedWithOfflinePayment(): void {
    this.totalBalance$.next(this.chargeMaster.amount_in_minor_currency);
    this.otherPaymentsModal$.next(true);
  }

}

interface Option {
  name: string;
  value: number;
}

// Product fulfillment popup methods for PosBillingSummaryComponent
export class PosBillingSummaryComponentHelpers {
  static hasProductsToFulfill(posDetails: PlanSummary | null): boolean {
    // Only show fulfillment popup for products that need confirmation (plan products with is_fulfilled: false)
    return !!(posDetails?.subscriptionProductsAndCharges?.products?.some(product => 
      product.is_plan_sku === true && product.is_fulfilled === false
    ));
  }

  static prepareProductFulfillmentItems(posDetails: PlanSummary | null): ProductFulfillmentItem[] {
    if (!posDetails?.subscriptionProductsAndCharges?.products) {
      return [];
    }

    // Only include products that need fulfillment confirmation (plan products with is_fulfilled: false)
    return posDetails.subscriptionProductsAndCharges.products
      .filter(product => product.is_plan_sku === true && product.is_fulfilled === false)
      .map(product => ({
        sku_id: product.sku_id,
        product_sku: product.product_sku,
        quantity: product.quantity,
        is_plan_sku: product.is_plan_sku,
        is_fulfilled: product.is_fulfilled || false
      }));
  }

  static updateProductFulfillmentStatus(posDetails: PlanSummary | null, updatedProducts: ProductFulfillmentItem[]): void {
    if (posDetails?.subscriptionProductsAndCharges?.products) {
      updatedProducts.forEach(updatedProduct => {
        const originalProduct = posDetails.subscriptionProductsAndCharges!.products.find(
          (product) =>
            product.sku_id === updatedProduct.sku_id && product.is_plan_sku === updatedProduct.is_plan_sku
        );
        if (originalProduct) {
          originalProduct.is_fulfilled = updatedProduct.is_fulfilled;
        }
      });
    }
  }
}
